export default __webpack_public_path__ + "static/media/delete.1a9198cf.svg";